import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useSnackBar } from "src/components/Reusable/CustomSnackbarProvider";
import { useRealmApp } from "src/store/RealmApp";
import { settingsKeys } from "../General/settings";
import { useAccessToken } from "../useAccessToken";

export const useDisconnectGoogleCalendar = () => {
  const app = useRealmApp();
  const snackbarCtx = useSnackBar();
  const queryClient = useQueryClient();
  const getValidAccessToken = useAccessToken();

  return useMutation({
    mutationFn: async (): Promise<{ message: string }> => {
      const accessToken = await getValidAccessToken();
      const res = await axios.delete(
        `https://us-east-1.aws.data.mongodb-api.com/app/${process.env.REACT_APP_APP_ID}/endpoint/calendarIntegration`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            userId: app.currentUser?.customData._id,
          },
        }
      );
      return res.data;
    },
    onError: () => {
      snackbarCtx.showSnackbar("Error disconnecting Google Calendar", "error");
    },
    onSuccess: () => {
      queryClient.invalidateQueries(
        settingsKeys.userSettings(app.currentUser?.customData._id)
      );
    },
  });
};
